import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-burger",
  "use": "spr-burger-usage",
  "viewBox": "0 0 142 122.5",
  "content": "<symbol viewBox=\"0 0 142 122.5\" id=\"spr-burger\">\n<style type=\"text/css\">\n\t#spr-burger .st0{fill:#004B8F;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M9.5,19h123c5.2,0,9.5-4.3,9.5-9.5S137.7,0,132.5,0H9.5C4.3,0,0,4.3,0,9.5S4.3,19,9.5,19z\" />\n\t<path class=\"st0\" d=\"M132.5,53H9.5C4.3,53,0,57.3,0,62.5S4.3,72,9.5,72h123c5.2,0,9.5-4.3,9.5-9.5S137.7,53,132.5,53z\" />\n\t<path class=\"st0\" d=\"M132.5,103.5H9.5c-5.2,0-9.5,4.3-9.5,9.5s4.3,9.5,9.5,9.5h123c5.2,0,9.5-4.3,9.5-9.5S137.7,103.5,132.5,103.5z\n\t\t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/burger.svg
// module id = 306
// module chunks = 0